module.exports = __webpack_public_path__ + "img/icon-more-blue.835f5a44.svg";